var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height pa-16",
    attrs: {
      "value": _vm.thisTab
    }
  }, [_c('v-layout', {
    staticClass: "h-100 mx-auto",
    staticStyle: {
      "max-width": "1224px"
    },
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary px-10",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('v-card', {
    staticClass: "py-20",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-layout', {
    staticClass: "pt-16 px-16",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "80"
    }
  }, [_vm._v("mdi-file-document-check-outline")])], 1), _c('v-card-title', {
    staticClass: "d-flex justify-center"
  }, [_vm._v(" 근로계약 전자서명에 대한 동의 ")]), _c('v-card-text', [_c('v-card', {
    attrs: {
      "outlined": "",
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-text', [_c('ul', {
    staticClass: "pl-20",
    staticStyle: {
      "list-style-type": "square"
    }
  }, [_c('li', [_vm._v("전자서명 및 전자문서의 법적 효력에 대해 동의합니다.")]), _c('li', [_vm._v("서명 완료 후 전송되는 전자문서를 원본으로 인정합니다.")]), _c('li', [_vm._v("모든 서명자가 전자서명에 정당한 권한을 가지는 것을 확인했습니다.")]), _c('li', [_vm._v("기타 자세한 내용은 전자서명 이용약관에 따라 동의합니다.")])])])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "v-btn-group flex-wrap my-12"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('prev');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    attrs: {
      "color": "grey-6"
    }
  }, [_vm._v("mdi-chevron-left")]), _c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v(" 이전 단계 ")])], 1), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('save');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 동의하고 서명 완료 ")]), _c('v-icon', {
    staticStyle: {
      "color": "white!important"
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }